import { useEffect, type PropsWithChildren } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { GlobalFooter } from '@fff-web/fff-global-footer';
import { GlobalNav } from '@fff-web/fff-global-nav';
import { isLoggedIn } from '../../services';

const JOB_POST = '/job-post';

type LayoutProps = {
  pageTitle?: string;
  isProtected?: boolean;
  meta?: {
    links?: { href: string }[];
    scripts?: { src: string }[];
  };
};

const Layout = ({
  children,
  pageTitle = 'Static Page',
  meta = {},
  isProtected = false,
}: PropsWithChildren<LayoutProps>) => {
  const location = useLocation();
  const isJobPostPage = location.pathname.includes(JOB_POST);

  useEffect(() => {
    if (isProtected) {
      isLoggedIn().then(
        ({ ok }) =>
          !ok &&
          window.location.replace(`${process.env.REACT_APP_LOGIN_URL}${window.location.href}`),
      );
    }
  }, [isProtected]);

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
        {meta &&
          meta.links &&
          meta.links.map(({ href, ...link }, index) => (
            <link key={`${href}${index}`} {...link} href={href} rel="stylesheet" type="text/css" />
          ))}
        {meta &&
          meta.scripts &&
          meta.scripts.map(({ src, ...script }, index) => (
            <script key={`${src}${index}`} {...script} src={src} />
          ))}
        {isJobPostPage && <link rel="canonical" href="https://fabfitfun.com/job-post" />}
      </Helmet>
      <GlobalNav env={process.env.REACT_APP_ENVIRONMENT} />
      {children}
      <GlobalFooter
        chatbotConfig={{
          agentId: process.env.REACT_APP_APPLIED_LABS_AGENT_ID,
          gigaAgentId: process.env.REACT_APP_GIGA_AGENT_TEMPLATE_ID,
        }}
      />
    </>
  );
};

export default Layout;
